export const NAV_ITEMS = [
  { label: "HOME", path: "/home" },
  { label: "SERVICES", path: "/services" },
  { label: "CONTACT US", path: "/contact" },
  { label: "CAREERS", path: "/careers" },
  { label: "ABOUT US", path: "/about" },
];
